import styled from 'styled-components';

export const Card = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;    
    border: 1px solid #e5e5e5;
    margin-bottom: 5px;
    box-shadow: 1px 1px 2px #d5d5d5;
    border-radius: 5px;
    padding: 10px;
`;

export const Header = styled.div`
    display: flex;
    font-size: 0.8em;
    color: #888;
`;

export const CreatedAt = styled.div`
    margin-right: 10px
`;

export const CreatedBy = styled.div`
    font-weight: bold;
`;

export const Body = styled.div`
    white-space: pre-wrap;
    overflow-wrap: break-word;
`;